module.exports = __webpack_public_path__ + "img/weixin.2269c21a.svg";